import { InjectionToken } from '@angular/core';

import { IHttpErrorHandler } from './models/http-error-handler.interface';

export const HTTP_ERROR_HANDLER = new InjectionToken<IHttpErrorHandler>('IHttpErrorHandler');
